module.exports = __webpack_public_path__ + "static/media/carousel4.8000f46a.jpeg";